// extracted by mini-css-extract-plugin
export default {"container":"checkOut_container__Vm1TO","cart":"checkOut_cart__JXy1w","order":"checkOut_order__-hSBX","btnDiv":"checkOut_btnDiv__khJnu","spacer":"checkOut_spacer__VQqi7"};